import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';
import { getRouteByActivityType } from 'src/app/board/activity/activity-shared/activity-shared-routes';
import { RouteActivityType } from 'src/app/board/activity/activity.constants';

export const activityLoansRoutes: MenuInterface[] = [
    {
        code: 'GestionParametrageApplicationVUP_ViewModel',
        route: getRouteByActivityType('ActivityParameters', RouteActivityType.Loans)
    },
    {
        code: 'LoansConfigPermanences',
        route: getRouteByActivityType('PermanencesSettings', RouteActivityType.Loans)
    },
    {
        code: 'GestionAFPAVUP_ViewModel',
        route: getRouteByActivityType('Catalog', RouteActivityType.Loans)
    },
    {
        code: 'LoansConfigFormsFields',
        route: getRouteByActivityType('FormField', RouteActivityType.Loans)
    },
    {
        code: 'LoansConfigStatusManagement',
        route: getRouteByActivityType('StatusParameters', RouteActivityType.Loans)
    },
    {
        code: 'LoansConfigForms',
        route: getRouteByActivityType('Forms', RouteActivityType.Loans)
    },
    {
        code: 'GestionDossierPretCreerVUP_ViewModel',
        route: [
            {
                content: 'activity/loans/record/create',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'GestionDossierPretHistoriqueVUP_ViewModel',
        route: [
            {
                content: 'activity/loans/record/list',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'GestionDossierPretHistoriqueVUP_ViewModel',
        route: [
            {
                content: 'activity/loans/record/list',
                focus: 'empty'
            }, 'content'
        ]
    },
];
